module.exports = __webpack_public_path__ + "media/images/icon_speaker-3d601de9dff8791230977ea6931e2ccd.svg";